import React from "react"

import { BetBoxWrapper } from "../elements/ElementsStyles"

import NumberOfBets from "./autoComponents/NumberOfBets"
import CashOut from "./autoComponents/CashOut"

interface AutoPilot_porps {
  firstBlock?: boolean
  autoPilotNumber: string
  disabled: boolean
  isPlaying: boolean
}

export default function AutoPilot({
  firstBlock,
  autoPilotNumber,
  disabled,
  isPlaying,
}: AutoPilot_porps) {
  return (
    <BetBoxWrapper className="auto" firstBlock={firstBlock} disabled={disabled}>
      <NumberOfBets autoPilotNumber={autoPilotNumber} disabled={isPlaying} />
      <CashOut autoPilotNumber={autoPilotNumber} disabled={isPlaying} />
    </BetBoxWrapper>
  )
}
